import axios from 'axios';

const api = axios.create({
    baseURL: process.env.VUE_APP_URL_API,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `${token}`;
        }else{
           return Promise.reject('Usuário não identificado para obtenção dos dados. Necessário realizar autenticação!');
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;